import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import addFavSpell from '../actions/setFavouriteSpells'
import getSpells from '../actions/getSpells'

function Spells(props){

    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(getSpells())
    },[])

    const spells = useSelector(state => state.spells)

    const clickHandler = spell => {
        console.log(spell)
        dispatch(addFavSpell(spell))
    }

    return(
        <div className="container">
            <div className="row">
                    {spells.map(spell => {
                        return (
                            <div key={spell._id} className="card m-3 spellCard" style={{width : 18+'rem'}}>
                                <div className="card-body">
                                    <h5 className="card-title">{spell.spell}</h5>
                                    <h6 className="card-subtitle mb-2 text-muted">{spell.type}</h6>
                                    <p className="card-text">{spell.effect}</p>
                                    <button onClick={(()=>{clickHandler(spell)})} className="btn btn-dark">Favourite</button>
                                </div>
                            </div>
                        )
                    })}
            </div>
        </div>
    )
}

export default Spells